import * as log from 'loglevel';

const NS = 'axiad_col_widths';

const storageKey = (tableId) => `${NS}__${tableId}`;

/**
 * Keep only entries that are usable column widths.
 * PM-18409: unknown / wrongly-typed entries are ignored rather than applied,
 * and corruption is logged so it can be investigated later.
 */
const sanitize = (data) => {
    const clean = {};
    let dropped = 0;
    Object.entries(data).forEach(([id, width]) => {
        if (typeof width === 'number' && Number.isFinite(width) && width > 0) {
            clean[id] = Math.round(width);
        } else {
            dropped += 1;
        }
    });
    return { clean, dropped };
};

export function readWidths(tableId) {
    try {
        const raw = localStorage.getItem(storageKey(tableId));
        if (!raw) return null;

        const data = JSON.parse(raw);
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            log.warn(`columnWidthStorage: discarding malformed entry for "${tableId}"`);
            return null;
        }

        const { clean, dropped } = sanitize(data);
        if (dropped > 0) {
            log.warn(
                `columnWidthStorage: ignored ${dropped} invalid column width(s) for "${tableId}"`,
            );
        }
        // Nothing usable left — fall back to the default layout.
        return Object.keys(clean).length > 0 ? clean : null;
    } catch (e) {
        log.warn(`columnWidthStorage: unreadable entry for "${tableId}"`, e);
        return null;
    }
}

export function writeWidths(tableId, widths) {
    try {
        const { clean } = sanitize(widths || {});
        if (Object.keys(clean).length > 0) {
            localStorage.setItem(storageKey(tableId), JSON.stringify(clean));
        }
    } catch (e) {
        // Storage can be full or unavailable (private mode); widths are a
        // convenience, so never let this break rendering.
        log.warn(`columnWidthStorage: could not persist widths for "${tableId}"`, e);
    }
}

export function clearWidths(tableId) {
    localStorage.removeItem(storageKey(tableId));
}

export function hasCustomWidths(tableId) {
    const w = readWidths(tableId);
    return w !== null && Object.keys(w).length > 0;
}
